"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRate = void 0;
const getRate = _ref => {
  let {
    showEscrow,
    escrowRate,
    rate
  } = _ref;
  return showEscrow && escrowRate ? escrowRate : rate;
};
exports.getRate = getRate;